const riot = require('riot');

riot.tag2('popup-column-filter', '<div class="relative w200 box-shadow-primary bg-white rounded-8 p8" ref="popup"> <div class="f fm fbw py4"> <div class="bold">{opts.title || \'カラム名で絞り込み\'}</div> <div class="p4 cursor-pointer mrn4" onclick="{close}"><i class="icon-close fs24 text-label_dark_medium"></i></div> </div> <div class="block mb8" onkeydown="{selectionList.onKeyDown}"> <div class="relative input light_secondary f fm mb8"><i class="icon-search text-label_dark_disabled fs16 mr8"></i> <input class="w-full" ref="search" placeholder="カラム名を入力" oninput="{onInput}"><i class="icon-close absolute t0 b0 r0 f fh h-full p6 fs16 cursor-pointer" onclick="{onDeleteValue}" if="{refs.search.value}"></i> </div> <div class="w-full border-bottom" if="{shouldShowSubmitButton}" data-is="item-selection-list" selected-class="bg-pale rounded-4"> <button class="w-full py6 hover-trigger hover-bg-pale hover-text-label_dark_primary rounded-4" onclick="{parent.submit}"> <div class="f fm px4"> <div class="s16 flex-fixed mr4"><i class="icon-check fs16"></i></div> <div class="f fm fbw w-full lh13 fs12"> <span>決定 </span><span class="px4 fs10 text-label_dark_medium">{app.shortcut.getCtrlKeyLabel()} + Enter</span></div> </div> </button> </div> <div class="w-full border-bottom" if="{shouldShowClearAllButton &amp;&amp; selected.size}" data-is="item-selection-list" selected-class="bg-pale rounded-4"> <button class="w-full py6 hover-trigger hover-bg-pale hover-text-label_dark_primary rounded-4" onclick="{parent.clearAll}"> <div class="f fm px4"> <div class="s16 flex-fixed mr4"><i class="icon-close fs16"></i></div> <div class="lh13 fs12">すべて選択解除</div> </div> </button> </div> <div class="overflow-scroll scrollbar-none transition-128" riot-style="max-height: {columns ? 178 : 0}px"> <div class="w-full" each="{column, index in getFilteredColumns()}" data-is="item-selection-list" item="{column}" selected-class="bg-pale rounded-4"> <button class="w-full py4 hover-trigger hover-bg-pale hover-text-label_dark_primary rounded-4" onclick="{parent.onClickColumn}"> <div class="f fm fbw px4"> <div class="f fm"> <div class="px4 flex-fixed"> <div class="s8 circle" riot-style="background-color: hsl({app.utils.stringToColorAngle( column.data.name )}, 60%, 60%);"></div> </div> <div class="font-lato lh13 fs12 line-clamp-1 word-break-all">{column.data.name}</div> </div> <div class="s16 flex-fixed"><i class="icon-check fs16 text-primary" if="{parent.isSelected(column.id)}"></i></div> </div> </button> </div> </div> </div> </div>', 'popup-column-filter input:focus,[data-is="popup-column-filter"] input:focus{outline:none !important}', '', function(opts) {
    this.mixin('selectionList');

    this.shouldShowSubmitButton = false;
    this.shouldShowClearAllButton = false;

    this.on('mount', async () => {
      this.columns = this.opts.columns;
      this.selected = new Set((this.opts.selectedColumns || []).map(c => c.id));
      if (this.selected.size) {
        this.shouldShowClearAllButton = true;
      }
      this.updateValue();
      this.update();
      requestAnimationFrame(() => {
        this.refs.search.focus();
      });
    });

    this.isSelected = (id) => {
      return this.selected.has(id);
    };

    this.onClickColumn = (e) => {
      this.toggleColumn(e.item.column);

      requestAnimationFrame(() => {
        this.refs.search.focus();
      });
    };

    this.toggleColumn = (column) => {
      if (this.selected.has(column.id)) {
        this.selected.delete(column.id);
      } else {
        this.selected.add(column.id);
      }
      this.shouldShowSubmitButton = true;
      this.shouldShowClearAllButton = false;
      this.update();
    };

    this.updateValue = () => {
      this.value = this.opts.columns.filter(c => this.selected.has(c.id));
    };

    this.submit = () => {
      this.updateValue();
      this.close();
    };

    this.clearAll = () => {
      this.selected.clear();
      this.submit();
    };

    this.onInput = (e) => {
      e.preventUpdate = true;
      this.debounceSearch();
    };

    this.debounceSearch = _.debounce(() => {
      this.update();
    }, 128);

    this.getFilteredColumns = () => {
      let value = this.refs.search.value;

      let columns = this.columns.slice().sort((a, b) => {
        const a_selected = this.isSelected(a.id);
        const b_selected = this.isSelected(b.id);
        if (a_selected === b_selected) return 0;
        if (a_selected) return -1;
        if (b_selected) return 1;
      });

      if (!value) {
        return columns;
      }
      else {
        return app.utils.filterItems(columns, value, 'data.name').flat();
      }
    };

    this.on('selectionList.keydown.enter', (e) => {
      e.preventDefault();
      if (this.shouldShowSubmitButton && (e.ctrlKey || e.metaKey)) {
        this.submit();
        return ;
      }
      this.refs.search.value = '';
      const item = this.selectionList.getSelectedItem();
      if (item) {
        const button = item.querySelector('button');
        button && button.click();
      }
    });

    this.on('selectionList.keydown.other', (e) => {
      this.shouldShowSubmitButton = false;
      this.shouldShowClearAllButton = false;
      this.update();

      if (document.activeElement !== this.refs.search) {

        this.refs.search.focus();
      }
    });
});